import { Typography, TextField, Box } from "@mui/material";
import { RateAppointmentContext } from "../context/rateAppointmentContext";
import React from "react";
import { IRateAppointment } from "../interface/iRateAppointment";

const maxCharacters = 500;

const PersonalFeedback = (): React.JSX.Element => {
  const {
    isLoading,
    rateAppointmentDto,
    setRateAppointmentDto,
  }: {
    isLoading: boolean;
    rateAppointmentDto: IRateAppointment;
    setRateAppointmentDto: React.Dispatch<
      React.SetStateAction<IRateAppointment>
    >;
  } = React.useContext(RateAppointmentContext);

  // Function to handle the change event of the text field
  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    // Prevent the default behavior of the checkbox
    event.preventDefault();

    // Prevent the event from bubbling up to parent elements
    event.stopPropagation();

    // Prevent more than maxCharacters value
    if (event.target.value.length > maxCharacters) {
      event.target.value = event.target.value.slice(0, maxCharacters);
    }

    // Update the state with the new checked value
    setRateAppointmentDto({
      ...rateAppointmentDto,
      personalFeedback: event.target.value,
    });
  };

  return (
    <Box sx={{ pt: 6 }}>
      <Typography
        variant="h6"
        color="initial"
        sx={{
          mb: 1,
          fontWeight: "bold",
          color: (theme) => theme.palette.primary.main,
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        Dein persönliches Feedback
      </Typography>
      <Box>
        <TextField
          disabled={isLoading}
          value={rateAppointmentDto.personalFeedback}
          onChange={handleTextFieldChange}
          placeholder="Was hat dir besonders geholfen? Was könnten wir verbessern?"
          multiline
          minRows={3}
          fullWidth
          id="outlined-basic"
          variant="outlined"
        />

        <Typography variant="caption" color="initial" sx={{ mb: 1 }}>
          {rateAppointmentDto.personalFeedback.length} / {maxCharacters} Zeichen
        </Typography>
      </Box>
    </Box>
  );
};

export default PersonalFeedback;
